import Model, { attr } from '@ember-data/model';
import { type ContactCustomPropertyInfo } from 'donor-elf-web/services/contacts-cache';

export default class ContactCustomPropertySettingModel extends Model {
  @attr() properties!: ContactCustomPropertyInfo[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'contact-custom-property-setting': ContactCustomPropertySettingModel;
  }
}
